import { ComponentStyle, Datetime, errorMessagesSection, faExclamationCircle, FormStyle,
    infoPlaceholderSection, React, InputError} from "@/imports-files/components/custom-datetime";

import "moment/locale/en-gb"; // Import moment locales
import "moment/locale/nb";
import "moment/locale/sv";
import "moment/locale/da";
import moment from "moment";
import MomentUtils from '@date-io/moment';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import { useTranslation } from "react-i18next";


export function CustomKeyboardPicker(props) {  
  const { t, i18n } = useTranslation();
  const localeMap = {
    en: "en-gb",
    sv: "sv",
    da: "da",
    no: "nb",
  };

  const locale = localeMap[i18n.language] || "en-gb";
  moment.locale(locale);

  const errorStyles = props.InputError?.(props.formik, props.name) || {};

    return (
      <div className= {`CustomDatePicker CustomKeyboardPicker`} style={{ ...errorStyles, ...props.inputProps.style }}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardDatePicker
                      autoOk
                      variant         =    "inline"
                      className       =   { props.className }
                      inputProps      =   { props.inputProps }
                      onChange        =   { props.onChange }
                      ref             =   { props.reference }
                      selected        =   { props.selected }
                      disabled        =   { props.inputProps?.disabled ? props.inputProps?.disabled : false }
                      minDate         =   { props.minDate}
                      format          =   { props.format }
                      value           =   { props.value ? props.value._d || props.value : null} 
                      emptyLabel      =   { props.emptyLabel ?  t('placeholder:select:date') : ''}
                      disableFuture   =   { props.disableFuture ? props.disableFuture : false}
                      disablePast     =   { props.disablePast ? props.disablePast : true}
                      minDateMessage  =   { props.minDateMessage ? props.minDateMessage : ''}
                      onClose         =   {props.onClose}
                      onOpen          =   {props.onOpen}
                      maxDate         =   { props.maxDate}
                      maxDateMessage  =   { props.maxDateMessage}
                      placeholder     =   { props.placeholder}
                      localMoment     =   {(currentMoment) => currentMoment.locale(locale)}
                />
              </MuiPickersUtilsProvider>
              {
                props.inputProps.style != undefined ?  errorMessagesSection( props.name, FormStyle, props.formik, props.custom_class || '', props?.custom_error_90 || '')
                                                    :  infoPlaceholderSection( props.infoPlaceholder, FormStyle)
              }
      </div>
    );
  }
  